import React, { Component, useEffect, useState } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModules } from "@ag-grid-community/all-modules";

import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-alpine.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";

import ItemNameCellRenderer from "./ItemNameCellRenderer";
import VendorCellRenderer from "./VendorCellRenderer";

import { getUserLocations } from "../../../store/Mini/actions";
import { ExportToExcel } from "../../Common/CQExportToExcel";

import GeneratePurchaseOrderModel from "./generatePurchaseOrderModel";

import {
  resetCellUpdate,
  getCompareQuotationData,
  PurchaseOrderData,
  GeneratePurchaseOrder,
  po_model_open,
} from "../../../store/CompareQuotation/actions";
import LoadingModel from "../../LoadingModel";

function PdfViewer({ url }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("📥 PdfViewer: fetching via proxy, url:", url);
    setLoading(true);
    setError(null);

    fetch(url)
      .then((res) => {
        console.log("📥 fetch response status:", res.status);
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        console.log("✅ Blob received, size:", blob.size);
        const objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ PdfViewer fetch error:", err);
        setError(err.message);
        setLoading(false);
      });

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  if (loading) return <p style={{ padding: 10 }}>⏳ Loading PDF...</p>;
  if (error)
    return <p style={{ padding: 10, color: "red" }}>❌ Failed: {error}</p>;

  return (
    <iframe
      src={blobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class CompareQuotation extends Component {
  constructor(props) {
    super(props);

    // this.state = this.createState();

    this.state = {
      ...this.createState(),
      selectedOrderLocation: null,
      showImageModal: false,
    };

    // this.PurchaseOrder = this.PurchaseOrder.bind(this);
    // this.PurchaseOrderRowData = this.PurchaseOrderRowData.bind(this);
    this.tog_static = this.tog_static.bind(this);
  }

  createState() {
    const topOptions = {
      alignedGrids: [],
      defaultColDef: {
        autoHeight: true,
        // editable: true,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 350,
      },
      suppressHorizontalScroll: true,
    };
    const bottomOptions = {
      alignedGrids: [],
      defaultColDef: {
        autoHeight: true,
        // editable: true,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 350,
        cellRenderer: "tcvendorCellRenderer",
      },
    };

    topOptions.alignedGrids.push(bottomOptions);
    bottomOptions.alignedGrids.push(topOptions);

    return {
      topOptions,
      bottomOptions,

      getRowHeight: function (params) {
        return 420;
      },
    };
  }
  componentDidUpdate() {
    if (this.props.loading === false) {
      if (this.props.newclm !== "" || this.props.newrow !== -1) {
        var rowNodes = this.gridApi.getDisplayedRowAtIndex(this.props.newrow);
        var params = {
          force: true,
          suppressFlash: true,
          columns: [this.props.newclm, "ItemName"],
          rowNodes: [rowNodes],
        };
        if (this.gridApi) {
          this.gridApi.refreshCells(params);
          this.props.resetCellUpdate();
        }
      }
    }
  }
  componentDidMount() {
    this.props.getUserLocations();
    this.props.getCompareQuotationData(
      this.props.AuditReport ? this.props.CQId : this.props.match.params.id,
    );
  }
  tog_static() {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
    }));

    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  getPDF() {
    this.props.history.push("/compareQutdoc/" + this.props.match.params.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={this.props.AuditReport ? "" : "page-content"}>
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Card className="p-0 ">
              <CardHeader className="bg-transparent border-bottom ">
                {!this.props.AuditReport && (
                  <>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          HeaderHead={[].concat.apply(
                            [],
                            this.props.RFQCellData?.map((header, i) => {
                              if (i === 0) {
                                return [header.headerName, ""];
                              } else {
                                return [header.headerName, "", "", ""];
                              }
                            }),
                          )}
                          Header={[].concat.apply(
                            [],
                            this.props.RFQCellData?.map((header, i) => {
                              if (i === 0) {
                                return ["Item Name", "Quantity"];
                              } else {
                                return [
                                  "Quantity",
                                  "Price",
                                  "Tax",
                                  "Gross Value",
                                ];
                              }
                            }),
                          )}
                          apiData={this.props.CQbodyData.map((item, key) => {
                            var nexarr = this.props.RFQCellData?.map(
                              (header) => {
                                if (header.CellName !== "ItemName") {
                                  if (item[header.CellName]) {
                                    return [
                                      !item[header.CellName].Quotationcheck
                                        ? item[header.CellName].Quantity
                                        : item[header.CellName].Quantity +
                                          "\n" +
                                          "Approved Qty " +
                                          item[header.CellName]
                                            .ApprovedQuantity,
                                      item[header.CellName].Price,
                                      item[header.CellName].tax +
                                        " %" +
                                        (item[header.CellName].taxtype === 1
                                          ? "Inclusive"
                                          : "Exclusive"),
                                      !item[header.CellName].Quotationcheck
                                        ? item[header.CellName].GrossValue
                                        : "Vendor Gross: " +
                                          item[header.CellName].GrossValue +
                                          "\n " +
                                          "Approved Gross: " +
                                          item[header.CellName]
                                            .updateGrossValue,
                                    ];
                                  } else {
                                    return [
                                      "Not Submited",
                                      "Not Submited",
                                      "Not Submited",
                                      "Not Submited",
                                    ];
                                  }
                                } else {
                                  return [];
                                }
                              },
                            );
                            var nexarr2 = [].concat.apply([], nexarr);

                            return [
                              item.ItemName.Name,
                              item.ItemName.Quantity +
                                " " +
                                item.ItemName.Quantity_unit.name,
                              ...nexarr2,
                            ];
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "COMPARE QUOTATION REPORT",
                            "",
                          ]}
                          fileName="COMPARE_QUOTATION_REPORT"
                        />
                        <div className="float-right ml-2">
                          <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light "
                            onClick={() => {
                              this.getPDF();
                            }}
                          >
                            Download PDF
                          </Button>
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/CompareQuotationDashboard"
                      className="action-icon text-primary mr-2"
                    >
                      {" "}
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                  </>
                )}
                <h5 className="card-title-18 pt-2 d-inline-block">
                  Compare Quotation
                </h5>
              </CardHeader>
              <CardBody className="p-2 ">
                <Row>
                  <Col md={8}>
                    <div>
                      <ul className="list-style-two p-0 ml-4  ">
                        <li className="clearfix">
                          <span className="ttl">RFQ No:</span>
                          <span className="dtl">
                            {this.props.RFQrowdata.code}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">RFQ Date:</span>
                          <span className="dtl">
                            {moment(
                              this.props.RFQrowdata.requestforquotation_date,
                            ).format("DD-MM-YYYY")}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">Compare Quotation No:</span>
                          <span className="dtl">
                            {this.props.CQRowData.code}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">Total Gross:</span>
                          <span className="dtl">
                            &#8377; {this.props.CQRowData.total}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  {!this.props.AuditReport && (
                    <Col md={4} className=" mt-0 p-4">
                      <div className="CompareBox ">
                        <Button
                          type="submit"
                          color="success"
                          size="lg"
                          block
                          // disabled={
                          //   this.props.POData.length === 0 ? true : false
                          // }
                          className="waves-effect waves-light mr-2"
                          onClick={() => {
                            // this.tog_static();
                            this.props.po_model_open(
                              this.props.match.params.id,
                            );

                            // this.PurchaseOrder();
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle-outline mr-2"></i>
                          Generate Purchase Order
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col md={this.state.showImageModal ? 8 : 12} className="m-1">
                    <Card className="pt-1">
                      <CardBody className="p-0">
                        {this.props.loading === true ? (
                          <div className="text-center pt-2">
                            <span className="font-size-22 text-danger">
                              Data not available{" "}
                            </span>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              height: "970px",
                            }}
                            className="ag-theme-balham"
                          >
                            <div
                              style={{
                                flex: "1 1 auto",
                                maxHeight: "600px",
                              }}
                            >
                              <AgGridReact
                                context={{
                                  componentParent: this,
                                }}
                                rowData={this.props.CQbodyData}
                                gridOptions={this.state.topOptions}
                                onGridReady={this.onGridReady}
                                // columnDefs={this.state.columnDefs}
                                columnDefs={this.props.RFQCellData.map(
                                  (vend, Key) => {
                                    if (Key === 0) {
                                      vend.field = vend.CellName;
                                      vend.width = 250;
                                      vend.wrapText = true;
                                      vend.pinned = "left";
                                      vend.suppressMovable = false;
                                      vend.lockPosition = true;
                                      vend.cellClass = "locked-col";
                                      vend.cellRenderer =
                                        "itemNameCellRenderer";

                                      vend.autoHeight = true;
                                    } else {
                                      vend.field = vend.CellName;
                                      vend.wrapText = true;
                                      vend.suppressMovable = false;
                                      vend.width = 250;
                                      vend.cellRenderer = "vendorCellRenderer";
                                    }
                                    return vend;
                                  },
                                )}
                                frameworkComponents={{
                                  vendorCellRenderer: VendorCellRenderer,
                                  itemNameCellRenderer: ItemNameCellRenderer,
                                }}
                                getRowHeight={this.state.getRowHeight}
                                // onGridReady={this.onGridReady.bind(this)}
                                // onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                modules={AllCommunityModules}
                              />
                            </div>
                            <div
                              style={{
                                flex: "none",
                                height: "370px",
                              }}
                            >
                              <AgGridReact
                                context={{
                                  componentParent: this,
                                }}
                                rowData={this.props.CQBodyTCData}
                                gridOptions={this.state.bottomOptions}
                                columnDefs={this.props.RFQCellData.map(
                                  (vend, Key) => {
                                    if (Key === 0) {
                                      vend.field = vend.CellName;
                                      vend.width = 250;
                                      vend.wrapText = true;
                                      vend.pinned = "left";
                                      vend.suppressMovable = false;
                                      vend.lockPosition = true;
                                      vend.cellRenderer =
                                        "itemNameCellRenderer";

                                      vend.autoHeight = true;
                                    } else {
                                      vend.field = vend.CellName;
                                      vend.wrapText = true;
                                      vend.suppressMovable = false;
                                      vend.width = 250;
                                      vend.cellRenderer = "vendorCellRenderer";
                                    }
                                    return vend;
                                  },
                                )}
                                frameworkComponents={{
                                  itemNameCellRenderer: ItemNameCellRenderer,
                                  vendorCellRenderer: VendorCellRenderer,
                                }}
                                getRowHeight={this.state.getRowHeight}
                                headerHeight="0"
                                modules={AllCommunityModules}
                                rowStyle={{
                                  fontWeight: "bold",
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                  {this.state.showImageModal &&
                    (() => {
                      const loc = this.state.selectedOrderLocation;
                      return (
                        (loc?.send_flag1 && loc?.image) ||
                        (loc?.send_flag2 && loc?.image2) ||
                        (loc?.send_flag3 && loc?.image3)
                      );
                    })() && (
                      <Col md={12} xl={3}>
                        <Card className="p-1">
                          <CardHeader>
                            <h5>Order Location Document:</h5>
                            <Button
                              color="secondary"
                              size="sm"
                              className="float-right"
                              onClick={() =>
                                this.setState({ showImageModal: false })
                              }
                            >
                              Close
                            </Button>
                          </CardHeader>
                          <CardBody className="p-0">
                            {(() => {
                              const loc = this.state.selectedOrderLocation;
                              let activeImage = null;
                              if (loc?.send_flag1 && loc?.image)
                                activeImage = loc.image;
                              else if (loc?.send_flag2 && loc?.image2)
                                activeImage = loc.image2;
                              else if (loc?.send_flag3 && loc?.image3)
                                activeImage = loc.image3;

                              if (!activeImage) {
                                return (
                                  <p style={{ padding: 10 }}>
                                    No document available
                                  </p>
                                );
                              }

                              let cleanUrl = activeImage.trim();
                              try {
                                const parsed = new URL(cleanUrl);
                                cleanUrl = parsed.pathname + parsed.search;
                              } catch (_) {
                                if (!cleanUrl.startsWith("/")) {
                                  cleanUrl = "/" + cleanUrl;
                                }
                              }

                              const isPdf = /\.pdf(\?.*)?$/i.test(cleanUrl);

                              return isPdf ? (
                                <PdfViewer url={cleanUrl} />
                              ) : (
                                <img
                                  src={cleanUrl}
                                  alt="Order Location"
                                  style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                  }}
                                />
                              );
                            })()}
                          </CardBody>
                        </Card>
                      </Col>
                    )}
                </Row>
                {!this.props.AuditReport && (
                  <CardFooter className="bg-transparent p-1">
                    <div className="float-right">
                      <Button
                        type="reset"
                        color="light"
                        className="waves-effect waves-light mr-2"
                        href="/CompareQuotationDashboard"
                      >
                        Back
                      </Button>
                    </div>
                  </CardFooter>
                )}
              </CardBody>
            </Card>

            {this.props.PO_Model && <GeneratePurchaseOrderModel />}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { userLocation } = state.Mini;
  const {
    RFQCellData,
    CQbodyData,
    Quotations,
    CQBodyTCData,
    POData,
    HideSubmiteData,
    loading,
    newrow,
    newclm,
    CQRowData,
    RFQrowdata,
    PO_Model,
  } = state.CompareQuotation;
  return {
    userLocation,
    RFQCellData,
    CQRowData,
    CQbodyData,
    Quotations,
    CQBodyTCData,
    POData,
    HideSubmiteData,
    loading,
    newrow,
    newclm,
    RFQrowdata,
    PO_Model,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  resetCellUpdate,
  getCompareQuotationData,
  PurchaseOrderData,
  GeneratePurchaseOrder,
  po_model_open,
})(CompareQuotation);
